import classNames from 'classnames';
import { Route, Switch, useSearchParams } from 'wouter';

import Icon from 'components/Icon/Icon';
import SearchField from 'components/SearchField';
import Sorting from 'components/Sorting';
import SubHeader from 'components/SubHeader';
import ProviderGamesPage from 'pages/ProviderGamesPage/ProviderGamesPage';
import useLayout from 'utils/layout';
import { Translation } from 'utils/translations';

import Providers from './Providers';

import styles from './ProvidersPage.module.scss';

const ProvidersPage = () => {
  const layout = useLayout();
  const [searchParams] = useSearchParams();

  return (
    <section className={classNames(styles['providers-layout'], styles[layout])}>
      <Switch>
        <Route path="/:provider">
          <ProviderGamesPage />
        </Route>

        <Route>
          <SubHeader>
            <div className={styles['sub-header']}>
              <Icon name="profile-circle" width={24} height={24} />
              <Translation message="all_providers" />
            </div>
          </SubHeader>
          <div className={styles['layout-content']}>
            <SearchField
              minLength={2}
              placeholder="search_provider"
              className={styles['search-form']}
            />
            <div className={styles['providers-info']}>
              <div className={styles['providers-info-label']}>
                <Icon name="providers.bold" />
                <p className={styles.label}>
                  <Translation message="all_providers" />
                </p>
              </div>
              <Sorting />
            </div>
            <Providers
              sortDirection={searchParams.get('sort') as 'asc' | 'desc'}
              search={searchParams.get('q') as string}
            />
          </div>
        </Route>
      </Switch>
    </section>
  );
};

export default ProvidersPage;
